export const getCSRFToken = () => {
  const match = document.cookie.match(/csrftoken=(\w+)/) ?? [];
  const token = match[1];

  return token;
};
